import * as THREE from 'three';
import {
  CARD1Web,
  MouseAction
} from '../../CoordUtils.js';

import font_helvetiker_regular from '@/assets/fonts/helvetiker_regular.typeface.json';

export class GroundTextLoader {
  constructor(textModel, sceneManager) {
    var dividerLineMaterial = new THREE.MeshBasicMaterial({
      color: textModel.textOption.color
    });
    this.textModel = textModel;
    this.sceneManager = sceneManager;
    this.modelMesh = this.draw(textModel.textOption, dividerLineMaterial);

  }

  draw(textOption, material) {

    var loader = new THREE.FontLoader();
    var font=loader.parse(font_helvetiker_regular);
    var options = {
                    size: textOption.size,
                    height: textOption.height,
                    weight: 'normal',
                    font: font,
                    bevelEnabled: false,
                    curveSegments: 12
                };
    this.textGeom = new THREE.TextGeometry(textOption.text, options);
    this.textGeom.computeBoundingSphere();
    //this.textGeom.translate(this.textGeom.boundingSphere.center)
    this.textMesh =  new THREE.Mesh(this.textGeom, [material]);
    var geometry = new THREE.SphereGeometry( 0.5, 32, 32 );
    var material = new THREE.MeshBasicMaterial( {color: 0xffff00} );
    var sphere = new THREE.Mesh( geometry, material );
    sphere.position.copy(this.textGeom.boundingSphere.center);
    this.sceneManager.scene.add( sphere );

    return this.textMesh;
  }

  loadModel(){
    return this.modelMesh;
  }

  setStake(startStake, endStake, lookAtPt){
    this.textModel.startStake = startStake;
    this.textModel.endStake = endStake;
    // TODO:计算旋转的角度
    this.modelMesh.lookAt(lookAtPt);
    this.modelMesh.rotateX(-Math.PI / 2)
    this.modelMesh.rotateZ(Math.PI)
  }

}


// WEBPACK FOOTER //
// ./src/plugins/drawings3D/modelDrawing/DirectModel/GroundTextLoader.js